<div class="d-flex flex-row-fluid w-100" [style.background-image]="'url(./assets/img/' + 'userprofile-bg.jpg)'"
     style="height: 400px; background-size: cover; background-position: left 27%; border-radius: .4rem">
  <div class="d-flex align-items-center text-center flex-column justify-content-center h-100 w-100"
       style="position: relative;">
    <div class="overflow-hidden text-start" style="height: 100%;width: 100%;top: 0;position: absolute;">
      <div *ngFor="let icon of icons" [ngStyle]="icon.pos" class="icon-container">
        <sb-icon style="font-size: x-large; color: white" [icon]="icon.name"></sb-icon>
      </div>
    </div>
    <sb-card classes="green-border">
      <div card-body>
        <div class="d-flex justify-content-between text-start">
          <div style="position: absolute;top: -67px;display: flex;">
            <div class="image-video-wrapper">
              <div (click)="pickProfileImage()" class="userPic cursor-pointer"
                   [style.backgroundImage]="avatarUrl?'url('+avatarUrl+')':''">
                <div class="userPicEdit">
                  <sb-icon class="icon-center" icon="edit"></sb-icon>
                </div>
              </div>
            </div>
            <div class="ml-4">
              <h2 style="color: #fdfeff;text-shadow: 0 0 10px #000;" class="font-weight-bolder">
                {{user?.user.name}}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </sb-card>
  </div>
</div>


<div class="px-0 px-sm-0 px-md-2 px-lg-4 px-xl-5 px-xxl-10 px-xxxl-10" style="margin-top: -100px">
  <div class="row">
    <div class="col-lg-3">
      <sb-card>
        <div card-body>
          <ul class="nav-tabs nav sidenav">
            <li class="nav-item">
              <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.userOverview"
                 [sbRouterLink]="util.RoutingID.userOverview">
                <span>
                  <sb-icon class="mr-3" icon="eye"></sb-icon>
                  {{'lang.globals.overview' | translate}}
                </span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.userSecurity"
                 [sbRouterLink]="util.RoutingID.userSecurity">
                <span>
                  <sb-icon class="mr-3" icon="security"></sb-icon>
                  {{'lang.globals.security' | translate}}
                </span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.userPermissions"
                 [sbRouterLink]="util.RoutingID.userPermissions">
                <span>
                  <sb-icon class="mr-3" icon="key"></sb-icon>
                  {{'lang.globals.permissions' | translate}}
                </span>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [sbRouterLinkActive]="'active'" [isLinkActive]="util.RoutingID.userSettings"
                 [sbRouterLink]="util.RoutingID.userSettings">
                <span>
                  <sb-icon class="mr-3" icon="setting"></sb-icon>
                  {{'lang.globals.settings' | translate}}
                </span>
              </a>
            </li>
          </ul>
        </div>
      </sb-card>
    </div>
    <div class="col-lg-9">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
